import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeCurrencyCommand extends BaseCommand {
  CommandName = "ChangeCurrency";
  Command: {
    Currency: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, currency: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Currency: currency };
  }
}
